import PropTypes from 'prop-types';
import { InvoicePreviewDownloaderComponent } from './InvoicePreviewDownloader';
import { useDownloadRadiologistInvoicePreview } from '../../hooks/radiologists/useDownloadRadiologistInvoicePreview';

const RadiologistInvoicePreviewDownloader = ({ invoiceId, invoiceNo }) => {
  const { loading: downloadingReport, getPreview } =
  useDownloadRadiologistInvoicePreview();

  const handlePreviewReport = async () => {
    try {
      await getPreview(invoiceId, invoiceNo);
    } catch (error) {
      console.error('Error previewing report:', error);
    }
  };

  return (
    <InvoicePreviewDownloaderComponent
      titleTooltip="Download Invoice Preview"
      loading={downloadingReport}
      onClick={handlePreviewReport}
    />
  );
};

RadiologistInvoicePreviewDownloader.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  invoiceNo: PropTypes.string.isRequired,
};

export default RadiologistInvoicePreviewDownloader;
